import React from "react";
import { Box, Typography } from "@mui/material";
import WorkflowPifTextField from "./WorkflowPifTextField";
import { PifSectionProps } from "./pifDetailsModel";
import { PIF_DETAILS_FIELDS } from "./pifWorkflowKeys";

const F = PIF_DETAILS_FIELDS;

/** pif-3 Contact — new hire and rehire only (an existing employee maintains their own). */
const WorkflowPifContactSection: React.FC<PifSectionProps> = ({ values, errors, reference, onChange }) => {
  const field = { values, errors, onChange };
  // One of the two is required, not both: each carries the star until either has a number.
  const needsAPhone = !values[F.homePhone]?.trim() && !values[F.cell]?.trim();
  return (
    <>
      <Typography component="h3" className="workflow-run__section-title">
        Contact
      </Typography>
      <Box className="workflow-run__grid">
        <WorkflowPifTextField {...field} fieldKey={F.address1} label="Address line 1" required />
        <WorkflowPifTextField {...field} fieldKey={F.address2} label="Address line 2" />
        <WorkflowPifTextField {...field} fieldKey={F.city} label="City" required />
        <WorkflowPifTextField {...field} fieldKey={F.state} label="State" maxLength={2} />
        <WorkflowPifTextField {...field} fieldKey={F.zip} label="Zip" required inputMode="numeric" maxLength={10} />
        <WorkflowPifTextField
          {...field}
          fieldKey={F.homePhone}
          label="Home phone"
          inputMode="tel"
          required={needsAPhone}
          hint="A home phone or a cell is required."
        />
        <WorkflowPifTextField
          {...field}
          fieldKey={F.cell}
          label="Cell"
          inputMode="tel"
          required={needsAPhone}
          hint="A home phone or a cell is required."
        />
        <WorkflowPifTextField {...field} fieldKey={F.email} label="Personal email" required={reference.emailRequired} inputMode="email" />
      </Box>
    </>
  );
};

export default WorkflowPifContactSection;
